/**
 * Shared status filter payload builder for dashboards.
 * Each dashboard passes its own filterValueToStatusesMap.
 */
export const createGetStatusFiltersPayload = filterValueToStatusesMap => {
  return filters => {
    const statuses = [];
    filters.forEach(element => {
      if (filterValueToStatusesMap[element.value]) {
        const correspondingOrderStatus =
          filterValueToStatusesMap[element.value].orderStatus;

        if (
          correspondingOrderStatus &&
          !statuses.includes(correspondingOrderStatus)
        ) {
          statuses.push(correspondingOrderStatus);
        }
      }
    });
    return { status: statuses };
  };
};
